export const GET_SHOP = "shop/get";
export const ADD_TO_SHOP = "shop/add";
export const ITEM_EXIST = "shop/exist";
export const UPDATE_SHOP = "shop/update";
export const DELETE_FROM_SHOP = "shop/delete";
